import { Control } from 'react-hook-form';
import { Checkbox } from '../../../../ui/components/ui/checkbox';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../../ui/components/ui/form';
import { OfferCheckoutFormValues } from '../offer-checkout-form/offer-checkout-form.schema';

/** SEPA only – same mandate text as the self-checkout. */
const SepaMandateCheckbox = ({ control }: { control: Control<OfferCheckoutFormValues> }) => (
  <FormField
    control={control}
    name="sepaMandateAccepted"
    render={({ field }) => (
      <FormItem>
        <div className="flex items-start gap-3">
          <FormControl>
            <Checkbox ref={field.ref} checked={field.value} onCheckedChange={(checked) => field.onChange(checked === true)} className="mt-0.5" />
          </FormControl>
          <FormLabel className="text-xs font-normal leading-relaxed text-[#082729]/50">
            Ich ermächtige 7i7®, Zahlungen von dem Konto mittels Lastschrift einzuziehen.
          </FormLabel>
        </div>
        <FormMessage />
      </FormItem>
    )}
  />
);

export default SepaMandateCheckbox;
